import {
  ItemWithStatus,
  useItemStatusList,
} from "../../components/ui/item-status/use-item-status-list";
import { useMTUs } from "../../queries/mtu/use-mtus";
import { useTasks } from "../../queries/tasks/use-tasks";

type Item = ItemWithStatus<{
  id: string;
  label: string;
  isPending?: boolean;
}>;

export function useMTUsWithStatus() {
  const { MTUs } = useMTUs();
  const { allTasks } = useTasks();

  const { itemsWithStatus, handleStatusChange } = useItemStatusList<Item>(
    MTUs?.map((x) => ({
      label: x.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code ?? "",
      id: x.DM_MaterialTrackingUnit_Id!,
      isPending: allTasks?.some(
        (y) =>
          y.Description ===
            x.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code &&
          y.Status?.StatusNId !== "Completed"
      ),
    })) ?? []
  );

  return { mtusWithStatus: itemsWithStatus, handleStatusChange };
}
